import {match, Pattern} from 'ts-pattern';

import {always} from 'ramda';

import {BusinessCaseSeriesDefinitionResponseBody, OrderDiscriminator} from '@dms/api/sales';

import {Nullish} from 'shared/web';

type CorrectiveTaxDocumentSeriesDefinition = Pick<
  BusinessCaseSeriesDefinitionResponseBody,
  | 'correctiveTaxDocumentSeriesId'
  | 'saleBrokerageCorrectiveTaxDocumentSeriesId'
  | 'sellerAsSupplierCorrectiveTaxDocumentSeriesId'
  | 'brokerageFeesCorrectiveTaxDocumentSeriesId'
>;

export type GetBusinessCaseCorrectiveTaxDocumentSeriesIdArgs = {
  orderDiscriminator: OrderDiscriminator | Nullish;
  isBrokerageBusinessCase: boolean;
  isSellerAsSupplier: boolean;
  seriesDefinition: CorrectiveTaxDocumentSeriesDefinition | Nullish;
};

/**
 * Selects the corrective tax document series for a business case order. Commission sales
 * (brokerage `SALE`) use the dedicated mode 2 series when the checkout has seller as supplier
 * enabled.
 */
export const getBusinessCaseCorrectiveTaxDocumentSeriesId = ({
  orderDiscriminator,
  isBrokerageBusinessCase,
  isSellerAsSupplier,
  seriesDefinition,
}: GetBusinessCaseCorrectiveTaxDocumentSeriesIdArgs) =>
  match([orderDiscriminator, isBrokerageBusinessCase, isSellerAsSupplier])
    .with(['SALE', false, Pattern.boolean], always(seriesDefinition?.correctiveTaxDocumentSeriesId))
    .with(
      ['SALE', true, true],
      always(seriesDefinition?.sellerAsSupplierCorrectiveTaxDocumentSeriesId)
    )
    .with(
      ['SALE', true, false],
      always(seriesDefinition?.saleBrokerageCorrectiveTaxDocumentSeriesId)
    )
    .with(
      ['PURCHASE_BROKERAGE_SALE', Pattern.boolean, Pattern.boolean],
      ['PURCHASE_BROKERAGE_FEES', Pattern.boolean, Pattern.boolean],
      always(seriesDefinition?.brokerageFeesCorrectiveTaxDocumentSeriesId)
    )
    .otherwise(always(seriesDefinition?.correctiveTaxDocumentSeriesId));
